import useNotifications from '@anm/hooks/useNotifications';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  hostedVideoSelectors,
  SaveVideoDataState
} from '../../../../store/modules/hostedVideo';
import NOTIFICATION_MESSAGES from '../notificationMessages';

const useVideoConfigsNotifications = (entity: SaveVideoDataState) => {
  const [canShow, setCanShow] = useState(true);

  const { notifications } = useNotifications({
    ...entity,
    isPending: canShow ? entity.isPending : false,
    ...NOTIFICATION_MESSAGES
  });

  const wasPosterChanged = useSelector(
    hostedVideoSelectors.selectWasPosterChanged
  );
  const wasConfigsChanged = useSelector(
    hostedVideoSelectors.selectWasConfigsChanged
  );

  useEffect(() => {
    const canHide = wasConfigsChanged && wasPosterChanged;
    const canShow = !wasConfigsChanged && !wasPosterChanged;

    canHide && setCanShow(false);
    canShow && setCanShow(true);
  }, [wasConfigsChanged, wasPosterChanged]);

  const videoConfigsNotifications = canShow ? notifications : [];

  return videoConfigsNotifications;
};

export default useVideoConfigsNotifications;
